import React, { useState } from "react";
import Navbar from "../components/Navbar";
import DivisionsTable from "./DisionsTable";

export default function Divisions(props) {

  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-20">
        <Navbar props={props} />

      </div>

      {/* Основной контент */}
      <main className="">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
            <DivisionsTable divisions={props.divisions} periods={props.periods} users={props.users} />
        </div>
      </main>
    </div>
  );
}
